"use strict";

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalReducer = void 0;

var actions_1 = require("./actions");

var INITIAL_STATE = {};

function modalReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions_1.OPEN_MODAL:
      {
        var _action$payload = action.payload,
            name = _action$payload.name,
            metadata = _action$payload.metadata;
        return Object.assign(Object.assign({}, state), _defineProperty({}, name, {
          open: true,
          name: name,
          metadata: metadata
        }));
      }

    case actions_1.CLOSE_MODAL:
      {
        var _name = action.payload.name;

        if (state[_name]) {
          return Object.assign(Object.assign({}, state), _defineProperty({}, _name, Object.assign(Object.assign({}, state[_name]), {
            open: false
          })));
        } else {
          // Invalid modal name
          return state;
        }
      }

    case actions_1.TOGGLE_MODAL:
      {
        var _name2 = action.payload.name;
        var modal = state[_name2] || {
          open: false
        };
        return Object.assign(Object.assign({}, state), _defineProperty({}, _name2, Object.assign(Object.assign({}, modal), {
          open: !modal.open
        })));
      }

    case actions_1.CLOSE_ALL_MODALS:
      {
        var newState = {};

        for (var _name3 in state) {
          newState[_name3] = Object.assign(Object.assign({}, state[_name3]), {
            open: false
          });
        }

        return newState;
      }

    default:
      return state;
  }
}

exports.modalReducer = modalReducer;